import { useBoolean } from '@dreryk/react-common';

import { MedicalDocumentationCreateModal } from './MedicalDocumentationCreateModal';

type MedicalDocumentationCreateModalOpenerRenderProps = { openModal: VoidFunction };
type MedicalDocumentationCreateModalOpenerProps = {
   readonly children: (renderProps: MedicalDocumentationCreateModalOpenerRenderProps) => JSX.Element;
   readonly patientId: number;
};

export const MedicalDocumentationCreateModalOpener = (
   props: MedicalDocumentationCreateModalOpenerProps
): JSX.Element => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <MedicalDocumentationCreateModal patientId={props.patientId} onCancel={closeModal} onCreate={closeModal} />
         ) : null}
      </>
   );
};
